import { CircleHelp } from "lucide-react";

import Checkbox from "components/core/Checkbox";
import { Flex } from "components/core/Flex";
import LucideIcon from "components/core/Icon/LucideIcon";
import { Text } from "components/core/Text";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/core/Tooltip";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  cropName?: string;
};

const SaveAsDefaultCheckbox = ({ checked, cropName = "this crop", onChange }: Props) => (
  <Checkbox checked={checked} onCheckedChange={onChange}>
    <Flex align="center" gap={1}>
      <Text color="subtle" variant="caption">
        Save as default for {cropName}
      </Text>
      <Tooltip>
        <TooltipTrigger asChild>
          <LucideIcon glyph={CircleHelp} size="small" />
        </TooltipTrigger>
        <TooltipContent>
          This value will be pre-filled the next time you record a harvest for this crop.
        </TooltipContent>
      </Tooltip>
    </Flex>
  </Checkbox>
);

export default SaveAsDefaultCheckbox;
